export default __webpack_public_path__ + "static/icon-awtgs-grade-1-260x260-d0835d6263b1087680ff0689318b9cfe.jpg";